import BaseEntity from './BaseEntity';
import CoverageEntry from './CommitCodeCoverage/CoverageEntry';
import Digest from './Digest';
export default class CommitCodeCoverage extends BaseEntity {
    constructor(codeCoverage) {
        super();
        this.digestDiff = null;
        this.entries = [];
        this.files = {};
        this.digest = new Digest(this.parseProperty(codeCoverage, 'digest'));
        if ('digestDiff' in codeCoverage && codeCoverage.digestDiff) {
            this.digestDiff = new Digest(this.parseProperty(codeCoverage, 'digestDiff'));
        }
        if ('entries' in codeCoverage) {
            this.entries = this.parseProperty(codeCoverage, 'entries').map(entry => new CoverageEntry(entry));
        }
        if ('files' in codeCoverage) {
            this.files = this.parseProperty(codeCoverage, 'files');
        }
    }
}
